export const loginRoute = '/login';

export interface RestoredSessionRouteState {
  hasToken: boolean;
  hasWorkspace: boolean;
  entryRoute: string;
}

export function sessionDestination(state: RestoredSessionRouteState): string {
  return state.hasToken && state.hasWorkspace ? state.entryRoute : loginRoute;
}

export function loginRouteDecision(state: RestoredSessionRouteState): true | string {
  const destination = sessionDestination(state);

  return destination === loginRoute ? true : destination;
}
